import React, { FC, ReactNode } from 'react';
import cn from '../../utils/classnames';
import FontAwesomeIcon from '../font-awesome-icon/font-awesome-icon';
import './alert.scss';

type AlertProps = React.HTMLAttributes<HTMLDivElement> & {
    variant?: string;
    dismissible?: boolean;
    onClose?: () => void;
    onClick?: () => void;
    children?: ReactNode;
    icon?: ReactNode;
    noBackground?: boolean;
};

const Alert: FC<AlertProps> = ({
    variant = 'primary',
    dismissible = false,
    onClose,
    children,
    className,
    icon,
    noBackground = false,
    ...props
}) => {
    return (
        <div
            className={cn(
                'alert',
                `alert-${variant}`,
                { 'alert-dismissible': dismissible, 'alert-no-background': noBackground },
                className
            )}
            role='alert'
            {...props}
        >
            {icon && <span className='alert-icon'>{icon}</span>}
            <span className='alert-text'>{children}</span>
            {dismissible && (
                <button type='button' className='alert-btn-close' aria-label='Close' onClick={onClose}>
                    <FontAwesomeIcon name='close' theme='black' width={12} height={12} />
                </button>
            )}
        </div>
    );
};

export default Alert;
